module.exports = __webpack_public_path__ + "static/media/waitlist-member-4.e1154af2.jpeg";